<script>
import { PopperWrapper } from "v-tooltip";

export default {
  ...PopperWrapper,
  name: "MenuDropdown",
  vPopperTheme: "menu-dropdown"
};
</script>

<style lang="scss">
.v-popper--theme-menu-dropdown {
  .v-popper__inner {
    border-radius: 2px;
    background: $occ-white;
    box-shadow: 0px 0px 10px rgba($color: $occ-black, $alpha: 0.16);
  }
  .v-popper__arrow-outer {
    border-color: $occ-white;
  }
}
</style>
